import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowLeft } from "lucide-react";
import { trackPurchaseFromSession } from "@/lib/metaPixel";

export default function ThankYou() {
  const [fired, setFired] = useState(null);

  useEffect(() => {
    const eventId = trackPurchaseFromSession();
    setFired(eventId);
  }, []);

  return (
    <main
      data-testid="thank-you-page"
      className="min-h-[100svh] bg-[#0B1F3D] text-[#F5EBD9] flex items-center justify-center px-6 py-24 relative overflow-hidden"
    >
      <div className="absolute inset-0 sunset-glow pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
        className="relative max-w-2xl text-center"
      >
        <div className="mx-auto mb-8 w-16 h-16 rounded-full bg-[#F5892E] flex items-center justify-center">
          <Check className="w-8 h-8 text-[#0B1F3D]" strokeWidth={3} />
        </div>

        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#F5892E]" />
          <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
            Плащането е успешно
          </span>
          <span className="h-px w-10 bg-[#F5892E]" />
        </div>

        <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mb-6">
          Добре дошъл в <span className="text-[#F5892E]">Играта на Имотите</span>.
        </h1>

        <p className="text-lg text-[#F5EBD9]/75 leading-relaxed mb-10 max-w-xl mx-auto">
          Билетът ти е потвърден. Ще получиш имейл със QR код и всички детайли. Ще се
          видим на 24 октомври 2026 в Хотел Черно Море, Варна.
        </p>

        <Link
          to="/"
          data-testid="thank-you-home-cta"
          className="btn-accent inline-flex items-center gap-3 px-8 py-4 rounded-full uppercase tracking-widest text-sm font-medium"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2.5} />
          Върни се на сайта
        </Link>

        {fired && (
          <div
            data-testid="thank-you-event-id"
            className="mt-10 font-mono text-[10px] uppercase tracking-[0.28em] text-[#F5EBD9]/30"
          >
            Ref: {fired.substring(0, 8)}
          </div>
        )}
      </motion.div>
    </main>
  );
}
